import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import buttonStyle from "./buttonStyle";
import {
    FaHome,
    FaLink,
    FaTrash,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";
import { BaseButton } from "../../componentes/baseComponents/BaseButton"
import { BaseDialog } from "../../componentes/baseComponents/base-dialog/BaseDialog"
import ProductTagParametersService from "./ProductTagParametersService";
import { DialogConformationGeneric } from "../../componentes/dialog/DialogConfirmationGeneric";

function reducer(state, action) {
    switch (action.type) {
        case "update": {
            return {
                ...state,
                ...action.payload
            };
        }
        case "clear": {
            return {
                ...initialState,
                open: true,
                rows: state.rows
            };
        }
        case "error": {
            return {
                ...state,
                success: false,
                error: true,
                message: action.message
            };
        }
        case "close_alert": {
            return {
                ...state,
                success: false,
                error: false
            };
        }
        case "open_dialog": {
            return {
                ...state,
                open: true
            };
        }
        case "close_dialog": {
            return initialState;
        }
        case "success": {
            return {
                ...state,
                success: true,
                error: false,
                message: action.message
            };
        }
        case "open_confirmation_dialog": {
            return {
                ...state,
                confirmationDialog: true,
                idDeletion: action.id
            };
        }
        case "close_confirmation_dialog": {
            return {
                ...state,
                confirmationDialog: false,
                idDeletion: 0
            };
        }
        case "close_confirmation_dialog_success": {
            const rowToRemove = state.idDeletion;
            const newRows = state.rows.filter(row => row.idEan !== rowToRemove);

            return {
                ...state,
                confirmationDialog: false,
                idDeletion: 0,
                success: true,
                error: false,
                rows: newRows
            };
        }
        case "close_confirmation_dialog_error": {
            return {
                ...state,
                confirmationDialog: false,
                idDeletion: 0,
                success: false,
                error: true
            };
        }
        default:
            throw new Error(`Invalid reducer action type: ${action.type}!`);
    }
}

const initialState = {
    open: false,
    success: false,
    message: "",
    error: false,
    id: 0,
    idProduto: 0,
    eanProduto: "",
    eanCaixa: "",
    eanDisplay: "",
    qtdeItensCx: 0,
    qtdeItensDisplay: 0,
    statusCode: 1,
    rows: [],
    confirmationDialog: false,
    idDeletion: 0
};

const columns = (t, handleDelete) => [
    {
        field: "eanProduto",
        headerText: t("eanProduto"),
        textAlign: 'center'
    },
    {
        field: "eanCaixa",
        headerText: t("eanCaixa"),
        textAlign: 'center'
    },
    {
        field: "eanDisplay",
        headerText: t("eanDisplay"),
        textAlign: 'center'
    },
    {
        field: "qtdeItensCx",
        headerText: t("qtdeItensCx"),
        textAlign: 'center'
    },
    {
        field: "qtdeItensDisplay",
        headerText: t("qtdeItensDisplay"),
        textAlign: 'center'
    },
    {
        field: "",
        headerText: "Excluir",
        textAlign: 'center',
        template: (row) => {

            const baseStyle = {
                cursor: "pointer",
                transition: "all 0.3s ease",
                border: "2px solid transparent",
                borderRadius: "8px",
                padding: "5px"
            };

            const hoverStyle = {
                borderColor: "#000000",
                backgroundColor: "rgba(0, 123, 255, 0.1)",
                transform: "scale(1.05)",
            };

            const activeStyle = {
                transform: "scale(0.95)",
                backgroundColor: "rgba(0, 123, 255, 0.2)",
            };

            return (
                <FaTrash
                    size={20}
                    color="#ff1100"
                    onClick={() => handleDelete(row.idEan)}
                    onMouseEnter={e => Object.assign(e.currentTarget.style, hoverStyle)}
                    onMouseLeave={e => Object.assign(e.currentTarget.style, baseStyle)}
                    onMouseDown={e => Object.assign(e.currentTarget.style, activeStyle)}
                    onMouseUp={e => Object.assign(e.currentTarget.style, hoverStyle)}
                    style={baseStyle}
                />
            );
        }
    }
];

const ProductTagParametersDialog = ({ _idProduto }) => {
    const { t } = useTranslation();
    const { control } = useForm();
    const idUsulogado = sessionStorage.getItem("userId");
    const buttonClass = buttonStyle();

    useEffect(() => {
        dispatch({
            type: "update",
            payload: {
                idProduto: _idProduto
            }
        });
    }, [_idProduto])

    const [state, dispatch] = useReducer(reducer, initialState);
    const { open, success, error, message, id, idProduto, eanProduto, eanCaixa, eanDisplay, statusCode, poBaseRawMaterial, rows, qtdeItensCx, qtdeItensDisplay } = state;

    function openDialog() {
        dispatch({ type: "open_dialog" });
    }

    function closeDialog() {
        dispatch({ type: "close_dialog" });
    }

    function setError(message) {
        dispatch({ type: "error", message });
    }

    function setSuccess(message) {
        dispatch({ type: "success", message });
    }

    function handleCloseAlert() {
        dispatch({ type: "close_alert" });
    }

    function handleChange(event) {
        dispatch({
            type: "update",
            payload: { [event.target.name]: event.target.value }
        });
    }

    function handleClear() {
        dispatch({ type: "clear" });
    }

    function handleSave() {

        const isUpdate = state.id !== 0;

        ProductTagParametersService
            .save({ ...state, idUsulogado: idUsulogado, idProduto: _idProduto, idEan: state.id })
            .then((response) => {

                let newRows = [];

                if (isUpdate) {
                    //replace old row
                    newRows = state.rows.map(row => {
                        if (row.idEan === state.id) {
                            return response.data;
                        } else {
                            return row;
                        }
                    });
                } else {
                    // add new row
                    newRows = [response.data, ...state.rows];
                }

                dispatch({
                    type: "update",
                    payload: {
                        success: true,
                        error: false,
                        rows: newRows,
                        eanProduto: "",
                        eanCaixa: "",
                        eanDisplay: "",
                        qtdeItensCx: 0,
                        qtdeItensDisplay: 0
                    }
                });
            })
            .catch(() => setError(t("saveError")));
    }

    useEffect(() => {
        if (open) {

            const request = {
                idProduto: _idProduto
            };

            ProductTagParametersService
                .searchByIdProduto(request)
                .then((response) => {
                    dispatch({
                        type: "update",
                        payload: {
                            rows: response.data
                        }
                    });
                });
        }
    }, [open]);

    function handleDelete(idEan) {
        dispatch({
            type: "open_confirmation_dialog",
            id: idEan
        });
    }

    async function confirmationDialogCallBack(confirmed) {
        if (!confirmed) {
            dispatch({ type: "close_confirmation_dialog" });
            return;
        }

        const hasDeleted = await ProductTagParametersService
            .delete(state.idDeletion)
            .then(() => true)
            .catch(() => false);

        if (hasDeleted) {
            dispatch({ type: "close_confirmation_dialog_success" });
        } else {
            dispatch({ type: "close_confirmation_dialog_error" });
        }
    }

    function handleRecordClick(e) {
        const deleteCellIndex = 5;

        if (e.cellIndex !== deleteCellIndex) {
            dispatch({
                type: "update",
                payload: {
                    id: e.rowData.idEan,
                    eanProduto: e.rowData.eanProduto,
                    eanCaixa: e.rowData.eanCaixa,
                    eanDisplay: e.rowData.eanDisplay,
                    qtdeItensCx: e.rowData.qtdeItensCx,
                    qtdeItensDisplay: e.rowData.qtdeItensDisplay
                }
            });
        }
    }

    return (
        <>
            <DialogConformationGeneric
                open={state.confirmationDialog}
                handleClose={confirmationDialogCallBack}
                message={"Esta operação não pode ser revertida, deseja continuar?"}
                maxWidth="md"
            />

            <BaseButton onClick={openDialog} label={t("tagParameters").toUpperCase()} className={buttonClass.blackButton} />

            <CustomAlert
                success={success}
                error={error}
                message={message}
                handleCloseAlert={handleCloseAlert}
                snackbar
                autoClose
            />

            <BaseDialog
                open={open}
                onClose={closeDialog}
                maxWidth="md"
                fullWidth
                title={t("tagParameters")}
                content={
                    <>
                        <GridInputRow>
                            <Grid item xs={4} sm={4} md={4}>
                                <InputField
                                    name="eanProduto"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={eanProduto}
                                    length={50}
                                    error={error && eanProduto === ""}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4}>
                                <InputField
                                    name="eanCaixa"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={eanCaixa}
                                    length={50}
                                    error={error && eanCaixa === ""}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4}>
                                <InputField
                                    name="eanDisplay"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={eanDisplay}
                                    length={50}
                                    error={error && eanDisplay === ""}
                                />
                            </Grid>
                        </GridInputRow>
                        <GridInputRow>
                            <Grid item xs={4} sm={4} md={4}>
                                <InputField
                                    name="qtdeItensCx"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={qtdeItensCx}
                                    length={50}
                                    error={error && qtdeItensCx === ""}
                                    inputProps={{ type: "number" }}
                                />
                            </Grid>
                            <Grid item xs={4} sm={4} md={4}>
                                <InputField
                                    name="qtdeItensDisplay"
                                    control={control}
                                    defaultValue=""
                                    onChange={handleChange}
                                    value={qtdeItensDisplay}
                                    length={50}
                                    error={error && qtdeItensDisplay === ""}
                                    inputProps={{ type: "number" }}
                                />
                            </Grid>
                        </GridInputRow>
                        <GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClear}
                                onClickSave={handleSave}
                            />
                        </GridInputRow>


                        {state.rows.length > 0 && (

                            <GridInputRow>
                                <DefaultDatagrid
                                    dataSource={rows}
                                    columns={columns(t, handleDelete)}
                                    recordClick={handleRecordClick}
                                />
                            </GridInputRow>

                        )}

                    </>
                }
            />
        </>
    );
};

export default ProductTagParametersDialog;
